<template>
	<v-row>
		<v-col>
			<v-form
				v-model="formIsValid.description"
				ref="descriptionForm"
				class="mb-8"
			>
				<ui-box :form="$refs.descriptionForm" :eager="!!localPass.id">
					<v-row>
						<v-col>
							<h5>Mobile Pass Description</h5>
							<span class="grey--text text--darken-1 text-body-2">
							</span>
						</v-col>
					</v-row>
					<!-- Name -->
					<v-divider class="mb-6 mt-4 opacity-80"></v-divider>
					<v-row>
						<v-col>
							<v-textarea
								v-model="localPass.mobile_pass_description"
								class="rounded-lg required"
								clearable
								counter="1000"
								label=""
								maxlength="1000"
								outlined
								placeholder="Enter a description for your pass here"
								rows="4"
								:rules="rules.mobile_pass_description"
								type="text"
							></v-textarea>
						</v-col>
					</v-row>
					<!-- End: Mobile Pass Description -->
				</ui-box>
			</v-form>

			<save-form
				:refs="$refs"
				:additional-validations="[isFormValid]"
				:is-saving="isSaving"
				:save-text="saveText"
				@cancel-action="cancelChanges"
				@save-action="saveDestination"
			></save-form>

		</v-col>
	</v-row>
</template>

<script>
import customizationMixin from './Mixins/customizationMixin';

export default {
	name: 'CustomDescription',
	mixins: [customizationMixin],
	data() {
		return {
			formIsValid: { description: false },
		};
	},
	computed: {
		isFormValid() {
			return this.formIsValid;
		},
	},
};
</script>




